import { render, staticRenderFns } from "./MaterialSensitivityInfo.vue?vue&type=template&id=16e7380b"
import script from "./MaterialSensitivityInfo.vue?vue&type=script&lang=js"
export * from "./MaterialSensitivityInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports